import React from "react";
import TickOrange from "src/assets/svgs/tickOrange.svg";
import WhiteCircle from "src/assets/svgs/whiteCircle.svg";
import {
  accessoiresSelected, accessoireSet, accessoireImgContainer,
  setTextContainer, variantText, accessoireImg, accessoiresOutOfStock,
  accessoireIcon, accessoireSetDesktop, accessoireSetMobile, accessoiresOutOfStockBadge
} from "./style.mod.scss";
import getImagePath from "helpers/get-image-path";

export const CreateSetDesktop = ({
  upsell, variantAdded,
  onClick
}) => {
  return (
    <div className={`${accessoireSet} ${accessoireSetDesktop} ${!upsell?.variant?.inStock && accessoiresOutOfStock} ${variantAdded ? accessoiresSelected : ""}`}
      onClick={() => { if (upsell?.variant?.inStock) onClick(); }}>
      <span className={accessoiresOutOfStockBadge}>
        {!upsell?.variant?.inStock ? "Ausverkauft" : ""}
      </span>
      <span className={accessoireIcon}>
        {variantAdded ? <TickOrange /> : <WhiteCircle />}
      </span>
      <div className={accessoireImgContainer}>
        <img className={accessoireImg} src={getImagePath(upsell?.image)} alt={upsell?.image?.alt} />

      </div>
      <div className={setTextContainer}>
        <span className={variantText}>{upsell.title}</span>
      </div>
    </div>
  );
};

export const CreateSetMobile = ({
  upsell, variantAdded,
  onClick
}) => (
  <div className={`${accessoireSetMobile} ${!upsell?.variant?.inStock && accessoiresOutOfStock} ${variantAdded ? accessoiresSelected : ""}`}
    onClick={() => { if (upsell?.variant?.inStock) onClick(); }}>
    <span className={accessoiresOutOfStockBadge}>
      {!upsell?.variant?.inStock ? "Ausverkauft" : ""}
    </span>
    <span className={accessoireIcon}>
      {variantAdded ? <TickOrange /> : <WhiteCircle />}
    </span>
    <div className={accessoireImgContainer}>
      <img className={accessoireImg} src={getImagePath(upsell?.image)} alt={upsell?.image?.alt} />

    </div>
    <div className={setTextContainer}>
      <span className={variantText}>{upsell.title}</span>
    </div>
  </div >
);
